import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import Typography from '@mui/material/Typography';
import { TableRowsRounded } from '@mui/icons-material';

export default function NotiAlertComfirm({
  open,
  setOpen,
  onButtonClick,
  invoiceNOItems,
}) {
  const handleClose = () => {
    setOpen(false);
  };

  // useEffect(() => {}, []);

  return (
    <div>
      <Dialog
        onClose={handleClose}
        fullWidth
        maxWidth="xs"
        aria-labelledby="customized-dialog-title"
        open={open}
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: '15px',
          },
        }}
      >
        <DialogActions sx={{ backgroundColor: '#D9D9D9' }}>
          <IconButton aria-label="close" onClick={handleClose}>
            <CancelOutlinedIcon />
          </IconButton>
        </DialogActions>
        <DialogContent dividers>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              color: 'primary.light',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            ใบแจ้งหนี้สามารถหักภาษี ณ ที่จ่ายได้
          </Typography>
          <Typography
            sx={{
              display: 'flex',
              justifyContent: 'center',
              // flexDirection: 'column',
              color: '#757575',
            }}
          >
            <div className="flex flex-col">
              {invoiceNOItems.map((row) => (
                <div>Invoice No. : {row}</div>
                // <div></div>
              ))}
            </div>
          </Typography>
          <Typography
            sx={{ display: 'flex', justifyContent: 'center', color: '#757575' }}
          >
            ต้องการยืนยันไม่หัก ณ ที่จ่าย ใช่หรือไม่
          </Typography>
          <DialogActions
            sx={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '10px',
            }}
          >
            <Button
              variant="contained"
              autoFocus
              onClick={onButtonClick}
              sx={{ color: '#fff', borderRadius: 15 }}
            >
              ตกลง
            </Button>
            <Button
              variant="contained"
              autoFocus
              onClick={handleClose}
              sx={{
                color: '#fff',
                borderRadius: 15,
                backgroundColor: 'grey',
                '&:hover': {
                  backgroundColor: 'red',
                },
              }}
            >
              ยกเลิก
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </div>
  );
}
